import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import useFetch from "../../../../context/useFetch";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiModal from "../../../shares/MuiModal";
import MuiUpload from "../../../shares/MuiUpload";
import { fixNumbers } from "../../../../utils";
import MuiButton from "../../../shares/MuiButton";
import MuiComboBox from "../../../shares/MuiComboBox";

// import Others files
import Customerimg from "../../../../imgs/customerAvatar.png";

const AddCustomer = (props) => {
  const [postData, setPostData] = useState({});
  const [userPic, setUserPic] = useState({});
  const [disableBtn, setDisableBtn] = useState(true);
  const [imgUrl, setImgUrl] = useState(Customerimg);
  const [adminCityList, setAdminCityList] = useState({ results: [] });
  const [selectedCity, setSelectedCity] = useState(undefined);
  const [searchedCityText, setSearchedCityText] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      address: "",
      phone_number: "",
      phone: "",
      city: "",
      email: "",
      store_name: "",
      attach_file: "",
      username: "",
      password: "",
    },
  });

  const AddCustomerApi = useFetch({
    method: "post",
    url: "Customer_Service",

    trigger: false,
    data: postData,
    caller: props.getFunc,
    argFunc: (res) => {
      if (res.data == "done") {
        reset();
        setUserPic({});
        setDisableBtn(true);
        setImgUrl(Customerimg);
        // toast.success("کاربر موردنظر با موفقیت ایجاد شد", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      } else if (res.data == "user_exist") {
        toast.error("مشتری با این نام کاربری وجود دارد", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append("username", data.username);
    formData.append("password", data.password);
    formData.append("name", data.name);
    formData.append("phone_number", fixNumbers(data.phone_number));
    formData.append("store_name", data.store_name);

    formData.append("email", data.email);
    formData.append(
      "city",
      adminCityList.results.length > 0
        ? adminCityList.results.filter((it) => it.id == selectedCity)[0].name
        : ""
    );
    formData.append("phone", fixNumbers(data.phone));
    formData.append("address", data.address);
    if (userPic instanceof File) {
      formData.append("attach_file", userPic, userPic.name);
    }

    setPostData(formData);
    AddCustomerApi.reFetch();
  };

  useEffect(() => {
    if (userPic instanceof File) {
      setImgUrl(URL.createObjectURL(userPic));
    }
  }, [userPic]);

  const getListOfCityApi = useFetch({
    method: "get",
    url: "City_Service",
    params: { name: searchedCityText },
    argFunc: (res) => {
      setAdminCityList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleSearchedCityText = (text) => {
    setSearchedCityText(text);
    if (text.length >= 1) {
      getListOfCityApi.reFetch();
    }
  };

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid md:grid-cols-3 md:gap-y-6 md:gap-x-4 mt-6">
              <div className="">
                <div className="mt-2 flex justify-center">
                  <img
                    className="w-20 h-20 md:w-40 md:h-40 rounded-full"
                    src={imgUrl}
                  />
                </div>
                <div className="mt-4">
                  <MuiUpload setImageFile={setUserPic} />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="نام کاربری "
                    variant="outlined"
                    size="small"
                    name="username"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام کاربری را وارد کنید",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="رمز عبور"
                    variant="outlined"
                    size="small"
                    name="password"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "رمز عبور را وارد کنید",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="md:mt-8">
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="نام و نام‌خانوادگی"
                    name="name"
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام و نام خانوادگی را وارد کنید",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="شماره همراه"
                    name="phone_number"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "شماره تلفن همراه را وارد کنید",
                      },
                      // pattern: {
                      //   value: /[0-9]{11}/,
                      //   message: "شماره تلفن باید 11 رقمی باشد",
                      // },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="نام فروشگاه"
                    name="store_name"
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام فروشگاه  را وارد کنید",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="ایمیل"
                    name="email"
                    control={control}
                    register={{
                      // required: {
                      //   value: true,
                      //   message: "ایمیل را وارد کنید",
                      // },
                      pattern: {
                        value:
                          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                        message: "فرمت ایمیل وارد شده صحیح نمی باشد",
                      },
                    }}
                  />
                </div>

                <div className="mt-6">
                  <MuiComboBox
                    size="small"
                    label="شهر"
                    forUser
                    name="city"
                    labelId="city-search-label"
                    id="city-search-select"
                    options={adminCityList.results}
                    placeholder="شهر"
                    setSelectedOption={setSelectedCity}
                    setSearchText={handleSearchedCityText}
                  />
                </div>
              </div>
              <div className="md:mt-8">
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="تلفن ثابت"
                    name="phone"
                    control={control}
                    // register={{
                    //   required: {
                    //     value: true,
                    //     message: "تلفن ثابت را وارد کنید",
                    //   },
                    // }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="آدرس"
                    name="address"
                    control={control}
                    // register={{
                    //   required: {
                    //     value: true,
                    //     message: "آدرس را وارد کنید",
                    //   },
                    // }}
                  />
                </div>
              </div>
            </div>
            <div className="text-left w-full mt-2">
              <MuiButton
                withoutOnClick
                type="submit"
                variant="contained"
                //     icon={<AddIcon />}
                color="success"
                text="ایجاد"
                disabled={AddCustomerApi.loading}
              />
            </div>
          </form>
        </div>
      </MuiModal>
    </>
  );
};

export default AddCustomer;
